import { render } from "./DocLoadComponent.vue?vue&type=template&id=17264516&scoped=true"
import script from "./DocLoadComponent.vue?vue&type=script&lang=js"
export * from "./DocLoadComponent.vue?vue&type=script&lang=js"

import "./DocLoadComponent.vue?vue&type=style&index=0&id=17264516&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17264516"]])

export default __exports__